import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NavigationPrompt from 'react-router-navigation-prompt';
import { Modal, Grid, Button } from 'semantic-ui-react';
import { setActiveSeasonAlertIgnore } from 'services/activeSeasonAlert/actions';
import { selectActiveSeasonAlertVisible } from 'services/activeSeasonAlert/selectors';
import { AppState } from 'services/types';
// @ts-ignore
import { makeSelectCurrentSeasonValue } from 'services/currentSeasonId/selectors';

function ActiveSeasonAlert(): React.ReactElement | null {
    const dispatch = useDispatch();
    const visible = useSelector((state: AppState) =>
        selectActiveSeasonAlertVisible(state)
    );
    const currentSeasonYear = useSelector((state: AppState) =>
        makeSelectCurrentSeasonValue('name')(state)
    );

    return (
        <NavigationPrompt
            when={(crntLocation, nextLocation) =>
                (!nextLocation ||
                    !nextLocation.pathname.startsWith(crntLocation.pathname)) &&
                visible
            }
        >
            {({ onConfirm }) => (
                <Modal open centered={false} size="tiny">
                    <Modal.Header>You’re viewing old data</Modal.Header>
                    <Modal.Content>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column>
                                    You are viewing old data from the{' '}
                                    {currentSeasonYear} season. Some functions
                                    may be limited.
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <Button
                                        onClick={(): void => {
                                            dispatch(
                                                setActiveSeasonAlertIgnore(true)
                                            );
                                            onConfirm();
                                        }}
                                        type="button"
                                        basic
                                        primary
                                    >
                                        View old data
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                </Modal>
            )}
        </NavigationPrompt>
    );
}

export default ActiveSeasonAlert;
